// +----------------------------------------------------------------------
// | 平台判断：决定「下载 App」按钮显不显示
// |
// | 三条必须一起看，少一条就会点出问题：
// |   ① 必须安卓 —— iOS 上根本没有 APK 可装，点开是个死链
// |   ② 必须非微信 —— 微信内置浏览器会拦掉 APK 下载（不是 bug，是微信的规则）。
// |      在微信公众号文章里点下载按钮，用户看到的是「已停止访问该网页」。
// |      与其让他撞一次墙，不如直接把按钮藏了。
// |   ③ 必须非已装 App —— App 壳里的 UA 带 Html5Plus，让它跳浏览器下载很蠢
// |
// | 为什么用 UA 判断而不是让后端给：
// |   这是个纯前端展示开关，多一次请求不值得。UA 判断在这里够用了
// |   （用户改 UA 骗自己看到按钮，损失也只是点到一个 404）。
// +----------------------------------------------------------------------

/** 微信内置浏览器 */
export function isWechat() {
  if (typeof navigator === 'undefined') return false;
  return /MicroMessenger/i.test(navigator.userAgent || '');
}

/** 安卓设备（含华为/小米等国产浏览器，它们 UA 里都有 Android） */
export function isAndroid() {
  if (typeof navigator === 'undefined') return false;
  return /Android/i.test(navigator.userAgent || '');
}

/** 已经在 App 壳里（HBuilderX 打包的 5+ App 会注入 Html5Plus） */
export function isInApp() {
  if (typeof window === 'undefined') return false;
  return !!(window.plus || /Html5Plus/i.test(navigator.userAgent || ''));
}

/** iOS（含 iPadOS 13+ 伪装成 Mac 的情况） */
export function isIOS() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  if (/iPhone|iPad|iPod/i.test(ua)) return true;
  // iPadOS 13 起 UA 是 "Macintosh"，靠触摸点数区分
  return /Macintosh/i.test(ua) && typeof navigator.maxTouchPoints === 'number' && navigator.maxTouchPoints > 1;
}

/**
 * 该不该显示「下载 App」按钮
 *
 * 现阶段的 APK 只有安卓包，所以：安卓 + 非微信 + 不在 App 内。
 * 将来 iOS 上架了，把 isIOS 的分支改掉即可（下载地址也要分流）。
 */
export function canDownloadApp() {
  return isAndroid() && !isWechat() && !isInApp();
}

/**
 * APK 下载地址
 *
 * 独立 CDN 域名，不走本站 —— 好处：
 *   ① 换包不用动前端构建，改这一处重新打 dist 即可（或直接在 nginx 302）
 *   ② 下载流量不占主站带宽
 *   ③ 将来做统计/短链也方便
 * 注意这个域名是 http（非 https）：本站若是 https，部分浏览器会拦混合内容，
 * 所以下载用的是 window.location.href 跳转而非 fetch/XHR（跳转不受混合内容限制）。
 */
export const APK_URL = 'http://release.dowmload.sxswyc.top/xiangxiang.apk';
